module.exports = __webpack_public_path__ + "img/Edson.b2c181d5.jpg";